import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormikProps } from 'formik';
import { SUBMOTIVE4, SUBMOTIVE4_DETAIL } from '../../../../../routes/paths';
import {
    asyncGetParamWithNestedParent,
    asyncGetSubmotive4Historical,
    asyncPatchSubmotive4Param,
    asyncPostSubmotive4Param,
} from '../../../../../services/param.service';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';
import { Param, ParamHistorical } from '../../../../../shared/types/param';

export const useSubmotive4Form = () => {
    const navigate = useNavigate();
    const { idSubmotive4 } = useParams();
    const [submotive4, setSubmotive4] = useState<Param>();
    const [loading, setLoading] = useState(false);
    const [formikSubmotive4Data, setFormikSubmotive4Data] =
        useState<FormikProps<Param>>();
    const [showHistorical, setShowHistorical] = useState(false);
    const [submotive4Historical, setSuptypeDPHistorical] =
        useState<ParamHistorical[]>();

    const isValidForm = formikSubmotive4Data?.isValid;

    const handleCleanAndBack = () => {
        formikSubmotive4Data?.resetForm();
        navigate(SUBMOTIVE4);
    };

    const handleSubmit = async () => {
        await formikSubmotive4Data?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: Param = formikSubmotive4Data?.values;

        let res: any | undefined = undefined;

        try {
            if (submotive4 && submotive4.id)
                res = await asyncPatchSubmotive4Param(submotive4.id, data);
            else res = await asyncPostSubmotive4Param(data);
        } catch (error) {}
        if (res?.items) {
            const item = Array.isArray(res?.items) ? res?.items[0] : res?.items;
            ToastSwal.fire({
                text: `¡Felicidades! el submotivo 4 se ${
                    submotive4 && submotive4.id ? 'actualizo' : 'creó'
                } satisfactoriamente.`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${SUBMOTIVE4_DETAIL}/${item.id}`);
        } else {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo ${
                    submotive4 && submotive4.id ? 'actualizar' : 'crear'
                } el submotivo 4. Por favor, asegúrate de ${
                    submotive4 && submotive4.id
                        ? 'diligenciar los datos correctamente'
                        : 'que no exista previamente'
                } e intenta nuevamente más tarde.`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    useEffect(() => {
        if (Boolean(idSubmotive4)) {
            setLoading(true);
            asyncGetParamWithNestedParent(idSubmotive4, 5)
                .then((submotive4: any) => {
                    if (!submotive4 || !submotive4.items) navigate(SUBMOTIVE4);
                    setSubmotive4(submotive4?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idSubmotive4]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetSubmotive4Historical(idSubmotive4)
                .then((resp) => {
                    if (resp) setSuptypeDPHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        submotive4,
        loading,
        isValidForm,
        handleSubmit,
        handleCleanAndBack,
        setFormikSubmotive4Data,
        submotive4Historical,
        showHistorical,
        setShowHistorical,
    };
};
